<template>
  <v-container id="wizard" tag="section">
    <validation-observer v-slot="{ valid }">
      <base-request-material-wizard
        v-model="tab"
        :available-steps="availableSteps"
        :items="tabs"
        class="mx-auto"
        :loading="loading"
        @click:next="sendRequestEmail(valid)"
        @click:prev="$emit('click:prev')"
      >
        <v-tab-item class="pb-1">
          <form>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12" md="12">
                <v-responsive max-width="500">
                  <div class="display-1 font-weight-medium mb-6 text-center">
                    <span class="grey--text text--darken-2">Selecione a empresa</span>
                  </div>
                  <general-select-empresa-sistema :tipo="'outlined'" :todas="true" />
                </v-responsive>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
      </base-request-material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
  import UsuariosService from '@/services/UsuariosService.js';
  import * as firebase from 'firebase/app';
  import 'firebase/auth';

  export default {
    components: {
      BaseRequestMaterialWizard: () => import('@/components/login/base/BaseRequestMaterialWizard'),
      GeneralSelectEmpresaSistema: () => import('@/components/general/SelectEmpresaSistema')
    },

    emits: ['click:prev'],

    data: () => ({
      logged: false,
      tab: 0,
      tabs: ['Solicitar Acesso'],
      empresa: '',
      profilePic: null,
      loading: false
    }),

    computed: {
      availableSteps() {
        const steps = [0];
        return steps;
      }
    },

    methods: {
      async sendRequestEmail() {
        this.loading = true;
        let user = await this.getInfoUser();

        UsuariosService.sendRequestEmail(user.nome, user.email)
          .then(() => {
            this.$toast.success('Solicitação Realizada.', '', { position: 'topRight' });
            this.$store.dispatch('setEmpresa', '');
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro ao solicitar acesso.', '', { position: 'topRight' });
            this.$store.dispatch('setEmpresa', '');
          })
          .finally(() => (this.loading = false));
      },

      async resetPassword(valid) {
        if (!valid) {
          this.$toast.error('Preencha o campo de Email', '', { position: 'topRight' });
          return;
        }

        firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.$toast.success('Email enviado com sucesso', '', { position: 'topRight' });
          })
          .catch((error) => {
            this.$toast.error('Falha ao enviar Email', '', { position: 'topRight' });
            console.error(error);
          });
      },

      getInfoUser() {
        this.$store.dispatch('setEmpresa', 'brd');
        let userUid = this.$store.getters.getUserUid;

        return UsuariosService.getUsuarioByUid(userUid)
          .then((response) => {
            return {
              nome: response.data.usuario.nome,
              email: response.data.usuario.email
            };
          })
          .catch(() => {
            return null;
          });
      }
    }
  };
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%
</style>